import { DUPLICATE_CAMPAIGNS_GROUP_SUCCESS, DUPLICATE_CAMPAIGNS_GROUP_ERROR } from './actionTypes';

export const duplicateCampaignsGroupSuccess = campaignsGroups => ({
    type: DUPLICATE_CAMPAIGNS_GROUP_SUCCESS,
    payload: campaignsGroups,
});

export const duplicateCampaignsGroupError = (campaignsGroupId, error) => ({
    type: DUPLICATE_CAMPAIGNS_GROUP_ERROR,
    payload: { campaignsGroupId, error },
});
